export const CREDIT_ERROR_TIPS: Record<string, string> = {
  '42G420000': 'セキュリティコードを確認して再度お試し下しください',
  '42G120000': '別のカードをご利用いただくか時間を空けて再度お試しください',
  '42G300000':
    '決済が保留されています。ご利用者様よりカード会社へご連絡をお願いします',
  '42G560000': '詳細についてはカード会社へ直接お問い合わせください',
  E21030007: 'クレジットカードの本人認証に失敗しました。',
};
